import { render, staticRenderFns } from "./Theraphy.vue?vue&type=template&id=62d3acab&"
import script from "./Theraphy.vue?vue&type=script&lang=js&"
export * from "./Theraphy.vue?vue&type=script&lang=js&"
import style0 from "./Theraphy.vue?vue&type=style&index=0&id=62d3acab&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports